import { createSelector } from 'reselect';

const getAllFlags = createSelector(
  (state) => state.fwf,
  (fwf) => fwf?.flags || {},
);

export default getAllFlags;
